// Note: createIcon is no longer available in Chakra UI v3
// Using custom SVG component instead

import { Icon } from "@chakra-ui/react"

export const CalendarIcon = ({ width, height, ...props }) => (
    <Icon as={"svg"} width={width} height={height} viewBox="0 0 46 46" {...props}>
        <g>
            <path
                d="M0,66.33a8.5,8.5,0,0,1,.673-1.306A2.8,2.8,0,0,1,3.024,63.87H4.231c0,.532-.024,1.04,0,1.545a2.8,2.8,0,0,0,5.588,0c.027-.494,0-.991,0-1.514h16.9c0,.518-.029,1.028.006,1.534a2.7,2.7,0,0,0,1.583,2.361,2.634,2.634,0,0,0,2.789-.218,2.69,2.69,0,0,0,1.213-2.18c.023-.493,0-.988,0-1.493,1.258-.1,2.433-.1,3.353.864a2.918,2.918,0,0,1,.876,2.048q.01,5.4,0,10.807c0,.085-.008.171-.013.282H33.754V72.337H2.832c-.007.138-.019.279-.019.421q0,9.291,0,18.583c0,.621.027.649.639.649h16.2V94.8H3.2A3.026,3.026,0,0,1,.084,92.484.709.709,0,0,0,0,92.341V66.33"
                transform="translate(0 -58.045)"
                className="fillsvg"
            ></path>
            <path
                d="M266.017,278.232c-.522-.114-1.048-.212-1.566-.343a11.263,11.263,0,1,1,13.955-12.456,2.326,2.326,0,0,0,.089.321v2.46a1.177,1.177,0,0,0-.082.233A11.23,11.23,0,0,1,270,277.9c-.5.128-1.014.222-1.521.332Zm9.651-11.218a8.424,8.424,0,1,0-8.517,8.391,8.438,8.438,0,0,0,8.517-8.391"
                transform="translate(-233.503 -233.039)"
                className="fillsvg"
            ></path>
            <path
                d="M65.67,0a1.76,1.76,0,0,1,.982,1.821c-.051,1.71-.014,3.423-.016,5.135a1.407,1.407,0,1,1-2.811,0c0-1.712.035-3.425-.016-5.135A1.756,1.756,0,0,1,64.791,0Z"
                transform="translate(-58.2 0.201)"
                className="fillsvg"
            ></path>
            <path
                d="M321.673,0a1.76,1.76,0,0,1,.982,1.821c-.051,1.71-.014,3.423-.016,5.135a1.407,1.407,0,1,1-2.811,0c0-1.712.035-3.424-.016-5.135A1.75,1.75,0,0,1,320.794,0Z"
                transform="translate(-291.708 0.201)"
                className="fillsvg"
            ></path>
            <rect
                id="Rectangle_1099"
                width="5.569"
                height="5.571"
                transform="translate(5.644 17.096)"
                className="fillsvg"
            ></rect>
            <rect
                id="Rectangle_1100"
                width="5.569"
                height="5.569"
                transform="translate(14.091 17.092)"
                className="fillsvg"
            ></rect>
            <rect
                id="Rectangle_1101"
                width="5.569"
                height="5.57"
                transform="translate(22.515 17.096)"
                className="fillsvg"
            ></rect>
            <rect
                id="Rectangle_1102"
                width="5.57"
                height="5.569"
                transform="translate(5.655 25.528)"
                className="fillsvg"
            ></rect>
            <rect
                id="Rectangle_1103"
                width="5.569"
                height="5.574"
                transform="translate(14.082 25.53)"
                className="fillsvg"
            ></rect>
            <path
                d="M327,327.079c0,.906,0,1.8,0,2.689a1.408,1.408,0,1,1-2.811,0q0-1.3-.005-2.591a.957.957,0,0,0-.034-.144h-1.283c-.468,0-.937,0-1.405,0a1.408,1.408,0,1,1-.02-2.811c.892,0,1.785,0,2.746,0,0-.212,0-.41,0-.607,0-.746-.009-1.493,0-2.24a1.405,1.405,0,0,1,2.81,0c.008.933,0,1.866,0,2.845h2.7a1.409,1.409,0,1,1,.02,2.812l-2.591.007a.7.7,0,0,0-.134.041"
                transform="translate(-291.855 -291.68)"
                className="fillsvg"
            ></path>
        </g>
    </Icon>
)
